import * as UI from "@iyk/ui"
import * as Accordion from "@iyk/ui/accordion"

import { each } from "@iyk/flow"
import { SectionLayout } from "./ui/section-layout.tsx"

export const FAQ = ({ items, className, ...props }: Props) => (
  <SectionLayout size="fluid" theme="dark" className={classForFAQ({ className })} {...props}>
    <h3 className="text-center text-xs-upper">FAQ</h3>

    <Accordion.Root className="mt-10">
      {each(items, (item) => (
        <Accordion.Item key={item.id} id={item.id}>
          <Accordion.Heading className="cursor-pointer">{item.heading}</Accordion.Heading>
          <Accordion.Content>
            {each(item.content, (__html, i) => (
              <p key={i} dangerouslySetInnerHTML={{ __html }} />
            ))}
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  </SectionLayout>
)

type Props = JSX.IntrinsicElements["div"] & {
  items: FAQItem[]
}

export type FAQItem = {
  id: string
  heading: string
  content: string[]
}

const classForFAQ = UI.cva(["text-gray-12 px-4 md:px-[max(16px,50dvw-190px)] w-full"])
